import React from 'react';
import { Link } from 'gatsby';

import { rhythm, scale } from '../utils/typography';

import './style.scss';
import { Toggle } from './toggle';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      address: '',
      fetching: false,
      result: null,
    };
  }

  render() {
    const { location, title, children } = this.props;
    const rootPath = `${__PATH_PREFIX__}/`;
    let header;

    if (location.pathname === rootPath) {
      header = (
        <h1
          style={{
            ...scale(1),
            marginBottom: rhythm(1.5),
            marginTop: 0,
            textTransform: 'lowercase',
          }}
        >
          <Link
            className="site-title"
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
      );
    } else {
      header = (
        <h1
          style={{
            marginTop: 0,
            textTransform: 'lowercase',
          }}
        >
          <Link
            className="site-title"
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
      );
    }
    return (
      <>
        <div
          style={{
            marginLeft: `auto`,
            marginRight: `auto`,
            maxWidth: rhythm(27),
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
          }}
        >
          <header>
            {header}
            <Toggle />
          </header>
          <main>{children}</main>
          <footer style={{ textAlign: 'center' }}>
            © {new Date().getFullYear()} Nick Scialli
          </footer>
        </div>
      </>
    );
  }
}

export default Layout;
